import { useGameContext } from '@/state/GameContext';
import { RARITY_COLORS } from '@/state/settings';
import type { ResultState } from '@/state/useGame';

export function ResultSlot() {
  const game = useGameContext();
  const shown: ResultState = game.result.kind === 'idle' ? game.preview : game.result;
  const loading = game.result.kind === 'loading';

  let content: React.ReactNode = null;
  let glow = false;
  let onClick: (() => void) | undefined;
  let badge: React.ReactNode = null;

  if (shown.kind === 'vanilla') {
    const url = game.urlFor(shown.itemId);
    content = url ? <img src={url} alt={shown.name} /> : shown.name;
    glow = true;
    badge = <span className="badge vanilla">Vanilla</span>;
    onClick = () => game.collect(shown.itemId, shown.count);
  } else if (shown.kind === 'custom') {
    const url = game.urlFor(shown.item.textureId);
    content = url ? <img src={url} alt={shown.item.name} /> : shown.item.name;
    glow = true;
    badge = (
      <span className="badge custom">Custom</span>
    );
    onClick = () => game.collect(shown.item.id, 1);
  } else if (shown.kind === 'invalid') {
    content = <span style={{ fontSize: 20 }}>!</span>;
    badge = <span className="badge invalid">Invalid</span>;
  } else if (shown.kind === 'error') {
    content = <span style={{ fontSize: 20 }}>!</span>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
      <div className="craft-row">
        <div className="arrow">&rarr;</div>
        <div
          className={`slot result-slot${glow ? ' glow' : ''}${shown.kind === 'custom' && !shown.cached ? ' reveal' : ''}`}
          onClick={onClick}
          title={onClick ? 'Click to collect' : undefined}
          role="button"
          aria-label="Crafting result"
        >
          {loading ? <div className="loading" /> : content}
        </div>
      </div>
      <div style={{ minHeight: 16 }}>{badge}</div>
      {shown.kind === 'vanilla' ? (
        <div className="muted" style={{ fontWeight: 600 }}>{shown.name} &times;{shown.count}</div>
      ) : null}
      {shown.kind === 'custom' ? (
        <div className="muted" style={{ fontWeight: 600, color: RARITY_COLORS[shown.item.rarity] || '#fff' }}>
          {shown.item.name} {shown.item.textureReused ? <span className="badge reuse" style={{ marginLeft: 4 }}>reused texture</span> : null}
        </div>
      ) : null}
      {shown.kind === 'invalid' ? (
        <div className="err" style={{ maxWidth: 240, fontSize: 11 }}>{shown.reason}</div>
      ) : null}
      {shown.kind === 'error' ? <div className="err" style={{ fontSize: 11 }}>{shown.message}</div> : null}
    </div>
  );
}
